<template>
  <v-container class="manualImportContainer">
    <h2>Manual cube creation</h2>
    <h5>Creating/deleting a cube in the selected environment for a selected order date</h5>
    <v-alert type="error" v-show="shwoMandatorAlert">
      {{ txt.mandatorAlert }}
    </v-alert>
    <v-progress-circular
        indeterminate
        color="primary"
        v-show="loadingData"
    ></v-progress-circular>
    <form>
      <v-row>
        <v-col cols="3" md="12">
          <v-autocomplete
            v-show="true"
            v-model="formState.selectedEnvironment"
            :items="formItems.environment"
            :search-input.sync="searchEnvironment"
            hide-selected
            label="Report Center Environment"
            solo
            persistent-hint
            chips
            return-object
          ></v-autocomplete>
          <v-menu
            ref="menuOrderDate"
            v-model="menuOrderDate"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formState.orderDate"
                label="Order Date"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="formState.orderDate" no-title scrollable>
              <div class="flex-grow-1"></div>
            </v-date-picker>
          </v-menu>
          <v-btn color="primary" class="searchButton ml-5" @click="createSalesCube"
            >{{ txt.btn.createSalesCube }}
          </v-btn>

          <v-btn color="primary" class="searchButton ml-5" @click.stop="dialogDeleteSalesCube = true"
            >{{ txt.btn.deleteSalesCube }}
          </v-btn>
          <v-dialog
            v-model="dialogDeleteSalesCube"
            max-width="290">
            <v-card>
              <v-card-title class="headline">Delete Sales Cube?</v-card-title>

              <v-card-text>
                Deleting the sales cube for the customer {{ !this.selectedMandators ? 'none' : this.selectedMandators.text}} for the day {{this.formState.orderDate}}. Proceed?
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="primary"
                  text
                  @click="dialogDeleteSalesCube = false">
                  No
                </v-btn>

                <v-btn
                  color="primary"
                  text
                  @click="dialogDeleteSalesCube = false, deleteSalesCube();">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn color="primary" class="searchButton ml-5" @click.stop="dialogDeleteRevenueItem = true"
            >{{ txt.btn.deleteRevenueItem }}
          </v-btn>
          <v-dialog
            v-model="dialogDeleteRevenueItem"
            max-width="290">
            <v-card>
              <v-card-title class="headline">Delete Revenue Item?</v-card-title>

              <v-card-text>
                Deleting the revenue items for the customer {{this.selectedMandators[0] == undefined ? 'none' : this.selectedMandators[0].text}} for the day {{this.formState.orderDate}}. Proceed?
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="primary"
                  text
                  @click="dialogDeleteRevenueItem = false">
                  No
                </v-btn>

                <v-btn
                  color="primary"
                  text
                  @click="dialogDeleteRevenueItem = false, deleteRevenueItem();">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </form>
  </v-container>
</template>

<script>

export default {
	name: 'AdminManualImport',

	props: [
		'loadingData',
		'selectedMandators',
	],
	data() {
		return {
			txt: {
				btn: {
					createSalesCube: 'Create Sales Cube',
					deleteSalesCube: 'Delete Sales Cube',
					deleteRevenueItem: 'Delete Revenue Item',
				},
				mandatorAlert: 'C`mon select a mandator, you coded it, you should know...',
			},
			formState: {
				selectedEnvironment: [],
				orderDate: new Date().toISOString().substr(0, 10),
			},
			formItems: {
				environment: ['LOCAL', 'QA', 'STAGE', 'LIVE'],
			},
			searchMandators: null,
			searchEnvironment: null,
			menuOrderDate: false,
			appNameShort: 'admin',
			shwoMandatorAlert: false,
			dialogDeleteSalesCube: false,
			dialogDeleteRevenueItem: false,
		}
	},
	methods: {
		createSalesCube() {
			const filterData = {
				mandators: this.selectedMandators,
				environment: this.formState.selectedEnvironment,
				orderDate: this.formState.orderDate,
			}
			if (this.selectedMandators == []) {
				this.shwoMandatorAlert = true
			} else {
				this.shwoMandatorAlert = false
				this.$emit('salesCubeCreation', filterData)
			}
		},
		deleteSalesCube() {
			const filterData = {
				mandators: this.selectedMandators,
				environment: this.formState.selectedEnvironment,
				orderDate: this.formState.orderDate,
			}

			if (this.selectedMandators.value == '') {
				this.shwoMandatorAlert = true
			} else {
				this.shwoMandatorAlert = false
				this.$emit('salesCubeDeletion', filterData)
			}
		},
		deleteRevenueItem() {
			const filterData = {
				mandators: this.selectedMandators,
				environment: this.formState.selectedEnvironment,
				orderDate: this.formState.orderDate,
			}
			if (this.selectedMandators.value == '') {
				this.shwoMandatorAlert = true
			} else {
				this.shwoMandatorAlert = false
				this.$emit('revenueItemDeletion', filterData)
			}
		},
	},
}
</script>

<style scoped>
.manualImportContainer {
  padding-top: 25px;
}
</style>
